import * as React from "react";
import { IconButton, Stack, SxProps, Typography } from "@mui/material";
import Banner from "..";
import CloseIcon from "@mui/icons-material/Close";
import { hexToRgbString } from "../../../Utils/Helpers/cssUtils";

export interface SelectModeBannerProps {
  sx?: SxProps;
  text: string;
  onCloseClick: React.MouseEventHandler;
  children: React.ReactNode;
}

const SelectModeBanner: React.FC<SelectModeBannerProps> = (props) => {
  const { text, children, onCloseClick, ...otherProps } = props;

  return (
    <Banner background="primary" {...otherProps}>
      <Stack direction="row" justifyContent="space-between" gap={2} width="100%">
        <Stack direction="row" alignItems="center" sx={{ flexShrink: 0 }}>
          <IconButton size="small" onClick={onCloseClick} color="whiteGhost">
            <CloseIcon />
          </IconButton>
          <Typography
            ml={0.5}
            variant="subtitle2"
            fontWeight={500}
            sx={(theme) => ({
              color: theme.palette.mode === "dark" ? theme.palette.text.primary : theme.palette.text.inverted,
            })}
          >
            {text}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          gap={1}
          sx={(theme) => ({
            flexGrow: 1,
            flexShrink: 1,
            minWidth: 0,
            position: "relative",
            "&::before": {
              content: '""',
              position: "absolute",
              display: "block",
              width: "16px",
              left: 0,
              zIndex: 2,
              height: "100%",
              background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, rgba(${hexToRgbString(
                theme.palette.primary.main
              )}, 0) 100%)`,
            },
          })}
          alignItems="center"
          justifyContent="flex-end"
          overflow="hidden"
        >
          {children}
        </Stack>
      </Stack>
    </Banner>
  );
};

export default SelectModeBanner;
